// Import necessary libraries
import React from 'react';
import { Container, Row, Col, Card } from 'react-bootstrap';
import FloatingButtons from './frontend/FloatingButtons';

// ThankYou component
const ThankYou = () => {
  return (
    <>
    <Container className="mt-5 mb-5">
      <Row className="justify-content-center">
        <Col md={6}>
          <Card>
            <Card.Body>
              <Card.Title>Thank You!</Card.Title>
              <Card.Text>
                Your payment was successful. Visit your <a href="/dashboard">dashboard</a>, select the booking from the calendar and fill your waivers to start the trip.
              </Card.Text>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
    </>
  );
};

export default ThankYou;
